import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  NavController,
  NavParams,
  ModalController,
  LoadingController,
  AlertController,
} from "ionic-angular";
import { FormBuilder, FormGroup } from "@angular/forms";
import * as moment from "moment";
import { Subscription } from "rxjs";

import { AuthProvider } from "./../../providers/auth/auth";
import { StaffProvider } from "../../providers/staff/staff";
import { RatingsProvider } from "../../providers/ratings/ratings";

import { ProfileImagePage } from "./../profile-image/profile-image";

import {
  IUser,
  IStaffUser,
  IRecruiterUser,
  IUserProfileImage,
} from "./../../interfaces/users";
import { IStaffType } from "./../../interfaces/staff";
import { IMonth, IDate } from "./../../interfaces/dates";
import { IAddress } from "../../interfaces/address";
import { IRating } from "../../interfaces/ratings";

@Component({
  selector: "page-my-profile",
  templateUrl: "my-profile.html",
})
export class MyProfilePage implements OnInit {
  title = "Edit Account";
  fbUser: any;
  user: any;
  userSubscription: any;
  userDataLoaded = false;
  hideProfileForm = true;
  profileImageForm: FormGroup;
  staffProfileForm: FormGroup;
  recruiterProfileForm: FormGroup;
  profileFormSubmitted = false;
  isPending = false;
  buttonText = "Save Details";
  isLoadingImage = false;
  hideUploadButton = false;
  hideProfileImage = true;
  isComplete = false;
  days = [];
  months = [];
  years = [];
  staffTypesSubscription: Subscription;
  staffTypes: Array<IStaffType> = [];
  isPhoneProvider = false;
  isSocialProvider = false;
  ratings: IRating[] = [];
  ratingsSubscription: Subscription;
  ratingsDataLoaded = false;
  ratingAverage = 0;
  ratingStaffTypes: IStaffType[] = [];
  ratingStaffTypesDataLoaded = false;
  skillsRating = 0;
  overallRating = 0;

  provinces: Array<string> = [
    "Eastern Cape",
    "Free State",
    "Gauteng",
    "KwaZulu-Natal",
    "Limpopo",
    "Mpumalanga",
    "Northern Cape",
    "North West",
    "Western Cape",
  ];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider,
    private staffProvider: StaffProvider,
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private formBuilder: FormBuilder,
    private ratingsProvider: RatingsProvider
  ) {
    this.profileImageForm = this.formBuilder.group({
      profileImage: [""],
      profileImageUrl: [""],
    });

    this.staffProfileForm = this.formBuilder.group({
      firstName: [""],
      lastName: [""],
      email: [""],
      cellphone: [""],
      idNo: [""],
      gender: [""],
      dobDay: [""],
      dobMonth: [""],
      dobYear: [""],
      preferredJobType: [""],
      province: [""],
    });

    this.recruiterProfileForm = this.formBuilder.group({
      firstName: [""],
      lastName: [""],
      email: [""],
      cellphone: [""],
      companyName: [""],
      registrationNumber: [""],
      companyAddressLine1: [""],
      companyAddressLine2: [""],
      companyAddressCity: [""],
      companyAddressProvince: [""],
      companyAddressPostal: [""],
      businessType: [""],
    });

    for (let i = 1; i < 32; i++) {
      this.days.push(i);
    }

    for (let i = 1; i < 13; i++) {
      let name: string;
      switch (i) {
        case 1: {
          name = "January";
          break;
        }
        case 2: {
          name = "February";
          break;
        }
        case 3: {
          name = "March";
          break;
        }
        case 4: {
          name = "April";
          break;
        }
        case 5: {
          name = "May";
          break;
        }
        case 6: {
          name = "June";
          break;
        }
        case 7: {
          name = "July";
          break;
        }
        case 8: {
          name = "August";
          break;
        }
        case 9: {
          name = "September";
          break;
        }
        case 10: {
          name = "October";
          break;
        }
        case 11: {
          name = "November";
          break;
        }
        case 12: {
          name = "December";
          break;
        }
        default: {
          //statements;
          break;
        }
      }
      const month: IMonth = {
        month: this.padLeft(i.toString(), "0", 2),
        name: name,
      };
      this.months.push(month);
    }

    let currentYear = new Date().getFullYear();
    let minYear = currentYear - 18;
    for (let i = 1950; i < minYear + 1; i++) {
      this.years.push(i);
    }
    this.years.reverse();
  }

  ngOnInit() {
    let loader = this.loadingCtrl.create({
      content: "Loading your profile...",
    });
    loader.present();

    this.authProvider.getFbUser().then((fbUser) => {
      console.log(fbUser);
      this.fbUser = fbUser;
      this.userSubscription = this.authProvider
        .getUserByUid(fbUser.uid)
        .subscribe(
          (data) => {
            console.log(data);
            this.user = data;
            this.userDataLoaded = true;

            if (this.user.profileImageUrl) {
              this.profileImageForm.patchValue(this.user);
            }

            this.loadStaffTypes();

            if (this.user.regType === "recruiter") {
              this.setupRecruiterForm();
            } else {
              this.setupStaffForm();
            }

            this.loadUserRatings(fbUser.uid);

            if (this.user.provider === "phone") {
              this.isPhoneProvider = true;
            } else {
              this.isSocialProvider = true;
            }

            console.log(`phone: ${this.isPhoneProvider}`);
            console.log(`social: ${this.isSocialProvider}`);

            loader.dismiss();
            return data;
          },
          (err) => {
            console.log(err);
          }
        );
    });
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  loadStaffTypes() {
    this.staffProvider.getStaffTypes().subscribe((staff) => {
      console.log(staff);
      this.staffTypes = staff;
      return staff;
    });
  }

  loadUserRatings(uid: string) {
    this.ratingsSubscription = this.ratingsProvider
      .getUserRatings(uid)
      .subscribe(
        async (data) => {
          console.log(data);

          let total = 0;
          if (data) {
            total = data.length * 5;
          }
          console.log(`total: ${total}`);

          let score = 0;
          data.forEach((r) => {
            score = score + r.rating;
          });
          console.log(`score: ${score}`);

          if (total === 0 && score === 0) {
            console.log(`raw average: 0`);
            this.ratingAverage = 0;
          } else {
            console.log(`raw average: ${(score / total) * 5}`);
            this.ratingAverage = Math.round((score / total) * 5);
          };
          console.log(`rounded average: ${this.ratingAverage}`);

          this.populateRatingStaffTypes(
            Array.from(
              new Set(data.map((rating: IRating) => rating.staffTypeId))
            )
          );

          if (await this.ratingsProvider.getUserSkillsRatingsPromise(uid)) {
            this.skillsRating = await (
              await this.ratingsProvider.getUserSkillsRatingsPromise(uid)
            ).overallRating;
          } else {
            this.skillsRating = 0;
          }
          console.log("skillsRating", this.skillsRating);
          console.log("staffrating", this.ratingAverage);

          this.overallRating = (this.skillsRating + this.ratingAverage) / 2;

          this.ratingsDataLoaded = true;
          return data;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  populateRatingStaffTypes(ratingStaffTypes: string[]) {
    console.log(ratingStaffTypes);
    this.staffTypesSubscription = this.staffProvider.getStaffTypes().subscribe(
      (data) => {
        console.log(data);

        ratingStaffTypes.forEach((rst) => {
          let newRatingStaffType = data.find((st) => st.id === rst);
          this.ratingStaffTypes.push(newRatingStaffType);
        });
        console.log(this.ratingStaffTypes);
        this.ratingStaffTypesDataLoaded = true;
        return data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  setupRecruiterForm() {
    this.recruiterProfileForm.patchValue(this.user);

    this.recruiterProfileForm.controls.companyAddressLine1.patchValue(
      this.user.address.line1
    );
    this.recruiterProfileForm.controls.companyAddressLine2.patchValue(
      this.user.address.line2
    );
    this.recruiterProfileForm.controls.companyAddressCity.patchValue(
      this.user.address.city
    );
    this.recruiterProfileForm.controls.companyAddressProvince.patchValue(
      this.user.address.province
    );
    this.recruiterProfileForm.controls.companyAddressPostal.patchValue(
      this.user.address.postalCode
    );
  }

  setupStaffForm() {
    this.staffProfileForm.patchValue(this.user);
    let month = moment(this.user.birthdate).format("M");
    let day = moment(this.user.birthdate).format("D");
    let year = moment(this.user.birthdate).format("YYYY");

    this.staffProfileForm.controls.dobDay.patchValue(day);
    this.staffProfileForm.controls.dobMonth.patchValue(
      this.padLeft(month, "0", 2)
    );
    this.staffProfileForm.controls.dobYear.patchValue(year);
  }

  updateStaffProfile() {
    this.profileFormSubmitted = true;

    let loader = this.loadingCtrl.create({
      content: "Saving your profile...",
    });
    loader.present();

    let uid = this.fbUser.uid;
    console.log(uid);

    let birthdate: IDate = {
      day: this.staffProfileForm.value.dobDay,
      month: this.staffProfileForm.value.dobMonth,
      year: this.staffProfileForm.value.dobYear,
    };

    let paddedDay = this.padLeft(birthdate.day.toString(), "0", 2);
    let dob = `${birthdate.year}${birthdate.month}${paddedDay}`;

    let user: IStaffUser = {
      uid: uid,
      firstName: this.staffProfileForm.value.firstName,
      lastName: this.staffProfileForm.value.lastName,
      email: this.staffProfileForm.value.email,
      cellphone: this.staffProfileForm.value.cellphone,
      idNo: this.staffProfileForm.value.idNo,
      gender: this.staffProfileForm.value.gender,
      birthdate: moment(`${dob}`, "YYYYMMDD").format(),
      preferredJobType: this.staffProfileForm.value.preferredJobType,
      province: this.staffProfileForm.value.province,
    };
    this.authProvider
      .updateStaffUser(user)
      .then(() => {
        console.log("user profile has been updated");
        loader.dismiss();

        let alert = this.alertCtrl.create({
          title: "Update successful!",
          message: "Your updated profile information has been saved.",
          buttons: [
            {
              text: "Ok",
              role: "cancel",
              handler: () => {
                console.log("Ok clicked");
                this.navCtrl.pop();
              },
            },
          ],
        });
        alert.present();

        this.profileFormSubmitted = false;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  updateRecruiterProfile() {
    this.profileFormSubmitted = true;

    let loader = this.loadingCtrl.create({
      content: "Saving your profile...",
    });
    loader.present();

    let uid = this.fbUser.uid;
    console.log(uid);

    if (this.recruiterProfileForm.valid) {
      let address: IAddress = {
        line1: this.recruiterProfileForm.value.companyAddressLine1,
        line2: this.recruiterProfileForm.value.companyAddressLine2,
        city: this.recruiterProfileForm.value.companyAddressCity,
        province: this.recruiterProfileForm.value.companyAddressProvince,
        postalCode: this.recruiterProfileForm.value.companyAddressPostal,
      };

      let user: IRecruiterUser = {
        uid: uid,
        firstName: this.recruiterProfileForm.value.firstName,
        lastName: this.recruiterProfileForm.value.lastName,
        email: this.recruiterProfileForm.value.email,
        cellphone: this.recruiterProfileForm.value.cellphone,
        companyName: this.recruiterProfileForm.value.companyName,
        registrationNumber: this.recruiterProfileForm.value.registrationNumber,
        businessType: this.recruiterProfileForm.value.businessType,
        address: address,
      };
      this.authProvider
        .updateRecruiterUser(user)
        .then(() => {
          console.log("user profile has been updated");
          loader.dismiss();

          let alert = this.alertCtrl.create({
            title: "Update successful!",
            message: "Your updated profile information has been saved.",
            buttons: [
              {
                text: "Ok",
                role: "cancel",
                handler: () => {
                  console.log("Ok clicked");
                },
              },
            ],
          });
          alert.present();

          this.profileFormSubmitted = false;
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad MyProfilePage");
  }

  updateProfileImage() {
    const userProfileImage: IUserProfileImage = {
      uid: this.user.uid,
      profileImage: this.profileImageForm.value.profileImage,
      profileImageUrl: this.profileImageForm.value.profileImageUrl,
    };
    this.authProvider.updateUserProfileImage(userProfileImage);
  }

  profileImageChange($evt) {
    console.log($evt);
    const self = this;
    const image: any = new Image();
    const file: File = $evt.target.files[0];
    const myReader: FileReader = new FileReader();
    myReader.onloadstart = function (startEvent: any) {
      console.log(startEvent);
    };
    myReader.onloadend = function (loadEvent: any) {
      console.log(loadEvent);
      image.src = loadEvent.target.result;
      self.openCropperModal(image);
    };

    myReader.readAsDataURL(file);
  }

  openCropperModal(image: any) {
    const self = this;
    let cropperModal = self.modalCtrl.create(ProfileImagePage, {
      image: image,
    });
    cropperModal.onDidDismiss((data) => {
      console.log(data);
      if (data) {
        if (data.profileImage !== "" && data.profileImageUrl !== "") {
          self.hideUploadButton = true;
          self.hideProfileImage = false;
          self.profileImageForm.controls.profileImage.setValue(
            data.profileImage
          );
          self.profileImageForm.controls.profileImageUrl.setValue(
            data.profileImageUrl
          );
          this.updateProfileImage();
        }
      }
    });
    cropperModal.present();
  }

  // TODO: create a utility service and stick this in there
  // Utility function
  padLeft(text: string, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr(size * -1, size);
  }
}



// WEBPACK FOOTER //
// ./src/pages/my-profile/my-profile.ts